import { generateVideoThumbstrip } from "./generateVideoThumbstrip";

export const buildVideoBlobMeta = async (blobSrc, workspaceWidth, workspaceHeight, isGenerateThumbstrip = true) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        video.src = blobSrc;
        video.crossOrigin = "anonymous";

        video.onloadedmetadata = () => {
            // Dynamically calculate video duration in minutes
            const { videoWidth: width, videoHeight: height, duration } = video;
            const durationInMinutes = Math.ceil(duration / 60);

            // Set video position, height and width to workspace
            let scaledWidth = workspaceWidth;
            let scaledHeight = (height / width) * scaledWidth;
            if (scaledHeight < workspaceHeight) {
                scaledHeight = workspaceHeight;
                scaledWidth = (width / height) * scaledHeight;
            }

            const scaledCenter = { x: scaledWidth / 2, y: scaledHeight / 2 };
            const workspaceCenter = { x: workspaceWidth / 2, y: workspaceHeight / 2 };

            const x = workspaceCenter.x - scaledCenter.x;
            const y = workspaceCenter.y - scaledCenter.y;

            // Generate single thumbnail
            const thumbCanvas = document.createElement("canvas");
            const thumbCtx = thumbCanvas.getContext("2d");
            thumbCanvas.width = workspaceWidth;
            thumbCanvas.height = workspaceHeight;

            video.currentTime = 0;
            video.onseeked = async () => {
                thumbCtx.drawImage(video, 0, 0, workspaceWidth, workspaceHeight);
                thumbCanvas.toBlob(async (thumbBlob) => {
                    const thumbnail = URL.createObjectURL(thumbBlob);
                    let thumbstrip = null;
                    if (isGenerateThumbstrip) {
                        try {
                            thumbstrip = await generateVideoThumbstrip(blobSrc);
                        } catch (err) {
                            console.error("Thumbstrip generation failed:", err);
                        }
                    }
                    resolve({
                        x,
                        y,
                        width: scaledWidth,
                        height: scaledHeight,
                        duration,
                        durationInMinutes,
                        thumbnail,
                        ...(isGenerateThumbstrip && { thumbstrip })
                    });
                }, "image/png");
            };
        };

        video.onerror = reject;
    });
};
